import { graphql } from '@/lib/graphql';

export const savedFilterItemFragment = graphql(`
  fragment SavedFilterItemFragment on SavedFilter {
    id
    name
    alertEnabled
    condition {
      query
      themes
      countries
      countryTags
      organizationTypes
      topicTags
      publishedStartDate
      publishedEndDate
    }
  }
`);
